import {addEventLodging, deleteEventLodging, updateEventLodging} from "../Lodging/BrowserDatabaseFunctions";


export const E_addEventLodgingResults = async (_incoming) => {
    console.log("E_addNewLodgingResults");

    try {
        if (_incoming?.result !== "ok") {
            console.log("Add result not ok");
            return null;
        }

        const eventId = _incoming.event_id;
        const newLodging = _incoming.lodging; // should already contain { id, temp_id?, ... }

        if (!eventId || !newLodging) {
            console.error("Missing event_id or Lodging in payload");
            return null;
        }

        // Persist to browser DB (best-effort)
        try {
            await addEventLodging(eventId, newLodging);
            console.log("Lodging added successfully");
        } catch (error) {
            console.error("Error adding Lodging to Browser database: ", error);
        }

        return null;

    } catch (e) {
        console.log("ERROR:", e);
        return null;
    }
};

export const E_updateEventLodgingResults = async (_incoming) => {
    console.log("E_updateEventLodgingResults");

    /*
        an Event Lodging was updated
     */

    try {
        const _result = _incoming.result;

        if (_result === "ok") {
            try {
                await updateEventLodging(_incoming.event_id, _incoming.lodging);
                console.log("Lodging updated successfully");
            } catch (error) {
                console.error("Error updating Lodging: ", error);
            }

            return null; // Return the updated lodging regardless of success or failure

        } else {
            console.log("Update result not ok");
            return null; // Return null if the result is not ok
        }

    } catch (e) {
        console.log("ERROROROR : " + e);
        return null; // Return null if there was a top-level error
    }
}

export const E_deleteEventLodgingResults = async (_incoming) => {
    console.log("E_deleteEventLodgingResults");

    /*
        an Event Lodging was deleted
     */


    try {

        const _result = _incoming.result;

        if (_result === "ok") {

            try {
                await deleteEventLodging(_incoming.event_id, _incoming.lodging_id);
                console.log("Lodging deleted successfully");
            } catch (error) {
                console.error("Error deleting Lodging: ", error);
            }

        }
    } catch (e){
        console.log("ERROROROR : "+e);
    }

}